__turbopack_context__.v({
  "className": "plus_jakarta_sans_e2b0cea1-module__VyMPoa__className",
  "variable": "plus_jakarta_sans_e2b0cea1-module__VyMPoa__variable",
});
